document.addEventListener("DOMContentLoaded", () => {
    HandleSpacing();
});

function HandleSpacing() {
    const overlapContent = document.querySelector('.overlap-content-section');

    if (overlapContent)
    {
        const previousSection = overlapContent.previousSibling.previousSibling;
        const previousSectionStyles = getComputedStyle(previousSection);
        previousSection.style.paddingBottom = (parseInt(previousSectionStyles.paddingBottom.replace('px', '')) + overlapContent.offsetHeight / 2) + 'px';
    
        const nextSection = overlapContent.nextSibling.nextSibling;
        const nextSectionStyles = getComputedStyle(nextSection);
        nextSection.style.paddingTop = (parseInt(nextSectionStyles.paddingTop.replace('px', '')) + overlapContent.offsetHeight / 2) + 'px';
    }
}